import angular from 'angular';
import loginConfig from './login.config';

import login from '../../containers/login';

const loginModule = angular.module('meredicte.login', [])
  .component('appLogin', login)
  .config(loginConfig);

export default loginModule;



// WEBPACK FOOTER //
// ./src/modules/login/login.module.js